export const NAMESPACE = "PassesConfirmations";

export const CONFIRMATIONS = {
  NOT_SENT: "not_sent",
  SENT: "sent",
  UNPAID: "unpaid"
};
